import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const FederatedUserInvitationAlreadyProcessed = () => (
  <BaseErrorDisplay
    title="There is a problem processing your invitation"
    subtitle="FEDERATED USER INVITATION ALREADY PROCESSED"
    description="This federated user invitation has already been completed."
    imgSrc={infoSvg}
  />
)
